const STORE_PROCESSES = (state, processes) => {
  state.processes = processes;
};
const STORE_PROCESS_TYPES = (state, processTypes) => {
  state.processTypes = processTypes;
};
const STORE_PROCESS_STATUS = (state, processStatus) => {
  state.processStatus = processStatus;
};
const STORE_PROCESS_DEPARTAMENTS = (state, departaments) => {
  state.departaments = departaments;
};
const STORE_PENDING_PROCESSES = (state, pendingProcesses) => {
  state.pendingProcesses = pendingProcesses;
}

export default {
  STORE_PROCESSES,
  STORE_PROCESS_STATUS,
  STORE_PROCESS_TYPES,
  STORE_PROCESS_DEPARTAMENTS,
  STORE_PENDING_PROCESSES
};
